import { FBApiMethod } from '@php-beam/packages/frontend/src/types/facebook';

export const facebookRequest = async <T extends object>(
  path: string,
  method: FBApiMethod,
  params: Record<string, string> = {},
) =>
  new Promise<T>((resolve, reject) => {
    window.FB.api(path, method, params, (response: any) => {
      if (response.error) {
        return reject(response.error);
      }

      return resolve(response);
    });
  });
